<div class="container-data form-field-density-4">
  <div class="float-add-button">
    <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Adicionar" (click)="novo()">
      <nz-icon nzType="plus"></nz-icon>
    </button>
  </div>
  <div class="edit-view">
    <div class="actions-toolbar">
          <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Salvar" (click)="salvar()">
            <nz-icon nzType="check"></nz-icon>
          </button>
          <span class="span1"></span>
          <button nz-button nzType="primary" nzDanger nzShape="circle" nz-tooltip="Cancelar" (click)="cancelEdit()">
            <nz-icon nzType="close"></nz-icon>
          </button>
          <span class="span1"></span>
          <nz-divider nzType="vertical"></nz-divider>

          <div class="fields">
            <search-input  entityname="Mktpcontract"  entitydesc="Contrato" [form]="formAction" controlname="CODECONTRACT" placeholder="Contrato" columnname="CODECONTRACT" class="no-padding-form-field" [loaddesc]="true" columndesc="Contrato" fieldname="CONTRACTNAME" >
            </search-input>
            <span class="span1"></span>
            <search-input  entityname="Mktpcompanies"  entitydesc="Empresa" [form]="formAction" controlname="CODECOMPANY" placeholder="Empresa" columnname="CODECOMPANY" class="no-padding-form-field" [loaddesc]="true" >
            </search-input>
          </div>
    </div>
    <div class="grid-view">
      <nz-spin [nzSpinning]="actionLoading" nzSize="large">
      <div class="props-grid props-grid-params props-grid-header">
          <div class="info-title">Tipo</div>
          <div class="info-title">Descrição</div>
          <div class="info-title">Nome</div>
          <div class="info-title">Instância Origem</div>
          <div class="info-title">Descrição da Instância</div>
          <div class="info-title">Ação</div>
      </div>
      <div class="props-grid props-grid-params grid-lines" *ngFor="let item of parameters;let index=index" (click)="editItem(item,index)">
          <div class="info-desc">{{getTypeDescription(item.parameterType)}}</div>
          <div class="info-desc">{{item.parameterDesc}}</div>
          <div class="info-desc">{{item.parameterName}}</div>
          <div class="info-desc">{{item.entityOrigem}}</div>
          <div class="info-desc">{{item.entityDesc}}</div>
          <div class="info-desc">
            <button nz-button nzType="text" nzShape="circle" nzDanger (click)="deleteItem($event,item)">
              <nz-icon nzType="delete"></nz-icon>
            </button>
          </div>
      </div>
      </nz-spin>
    </div>
  </div>
  <form (ngSubmit)="addItem()" #itemForm="ngForm">
    <div class="detail-item" *ngIf="visibleParam">
      <div class="detail-item-tipo-box-main">
        <div class="detail-item-tipo-box">
          <div class="detail-item-tipo">
            <div class="tem-field">
              <label class="tem-field-label">Tipo<span class="tem-field-required"> *</span></label>
              <nz-select [(ngModel)]="parameterType" required name="pt" nzPlaceHolder="Tipo">
                <nz-option *ngFor="let item of types" [nzValue]="item.type" [nzLabel]="item.description"></nz-option>
              </nz-select>
            </div>
            <div class="tem-field" *ngIf="parameterType=='R'">
              <label class="tem-field-label">Entidade<span class="tem-field-required"> *</span></label>
              <nz-select [(ngModel)]="entityOrigem" [required]="parameterType=='R'" (ngModelChange)="onSelectEntity()" name="et" nzPlaceHolder="Entidade" nzShowSearch>
                <nz-option *ngFor="let item of entityOrigemList" [nzValue]="item.entityName" [nzLabel]="item.entityName + ' - ' + item.entityDesc"></nz-option>
              </nz-select>
            </div>

          </div>
          <div class="tem-field">
            <label class="tem-field-label">Nome<span class="tem-field-required"> *</span></label>
            <nz-input-group [nzSuffix]="clearName">
              <input nz-input type="text" pattern="[A-Z]*" onlyalpha (ngModelChange)="parameterName = $event.toUpperCase()" [ngModel]="parameterName" required [disabled]="parameterType=='R'" name="pn" placeholder="Nome">
            </nz-input-group>
            <ng-template #clearName>
              <nz-icon *ngIf="parameterName && parameterType!='R'" nzType="close-circle" class="clear-icon" (click)="parameterName=''"></nz-icon>
            </ng-template>
          </div>
          <div class="tem-field">
            <label class="tem-field-label">Descrição<span class="tem-field-required"> *</span></label>
            <nz-input-group [nzSuffix]="clearDesc">
              <input nz-input type="text" [(ngModel)]="parameterDesc" required name="pd" placeholder="Descrição">
            </nz-input-group>
            <ng-template #clearDesc>
              <nz-icon *ngIf="parameterDesc" nzType="close-circle" class="clear-icon" (click)="parameterDesc=''"></nz-icon>
            </ng-template>
          </div>
        </div>
        <div class="detail-item-tipo-box-listoption" *ngIf="parameterType=='L'">
            <div class="list-option-main">
              <div class="tem-field full">
                <label class="tem-field-label">Lista de Opções (Valor=Descrição)</label>
                <textarea nz-input
                placeholder="Lista de Opções (Valor=Descrição)"
                aria-label="ListaOpcoes"
                [(ngModel)]="listOptionStr" name="lo" [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
              </div>
            </div>
        </div>
      </div>
      <div class="action-button">
        <button nz-button nzType="primary" nzShape="circle" type="submit" [disabled]="itemForm.invalid">
          <nz-icon nzType="check"></nz-icon>
        </button>
      </div>
    </div>
  </form>
</div>
